import { FC, Dispatch, SetStateAction, useEffect } from "react";
import Empty from "./Empty";
import Pagination from "./Pagination";
import template from "./template"
import CardPro from "../../../../components/Cards/Cards";
import { ViewName, UnitType } from "../../../../components/Cards/templateCard/types";
import { ProjectDetailType } from "../types";
import { useParams } from "react-router-dom";

// hooks
import { useDetailProjectUnit } from "../../hooks/useDetailProjectUnit";
import { useTowerUnits } from "../../hooks/useTowerUnits";


interface ResultsProps {
    viewName: ViewName;
    detailProject: ProjectDetailType;
    sort?: string;
    type?: string;
    filters?: Record<string, string | number>;
    setFilters: Dispatch<SetStateAction<Record<string, string | number>>>;
    isDepto: boolean;
}

const Results: FC<ResultsProps> = ({ sort, viewName, detailProject, type, filters, isDepto, setFilters }) => {
    const { id } = useParams();

    const { towerUnitsData, towerUnitsLoading, fetchTowerUnits } = useTowerUnits();
    const { dataDetailUnit, detailProjectUnitLoading, getDataDetailUnit, paginator } = useDetailProjectUnit();

    const getTower = ({ load }: { load: boolean }) => {
        if (viewName === "Tower") {
            if (id && !towerUnitsLoading) {
                fetchTowerUnits(id as string, filters as Record<string, string | number>, load);
            }
        }
    }
    const getOthersData = ({ load }: { load: boolean }) => {
        if (viewName !== "Tower") {
            if (id && !detailProjectUnitLoading) // Evita llamar si la vista anterior no es Tower porque sería redundante
                getDataDetailUnit(id as string, filters as Record<string, string | number>, sort as string, load);
        }
    }
    const getData = ({ load }: { load: boolean }) => {
        getTower({ load });
        setFilters((s) => ({ ...s, page: 1 }))
        getOthersData({ load });
    }

    useEffect(() => {
        getTower({ load: true });
    }, [viewName, id, JSON.stringify(filters)]);

    useEffect(() => {
        getOthersData({ load: true });
    }, [viewName, id, JSON.stringify(filters), sort]);

    const isLoading = detailProjectUnitLoading || towerUnitsLoading;
    const data = isDepto ? towerUnitsData : dataDetailUnit;
    const isEmpty = !(dataDetailUnit?.length > 0 || towerUnitsData?.length > 0);
    const Wrapper = template[viewName];

    return (
        <main className="col-span-6 px-4 md:px-0">
            <div className="w-full h-full max-w-full overflow-x-auto">
                {(isEmpty && !isLoading)
                    ? <Empty />
                    : <Wrapper
                        viewName={viewName}
                        data={data}
                        detailProject={detailProject}
                        sort={sort}
                        type={type}
                        getData={getData}
                        isLoading={isLoading}
                    >
                        {dataDetailUnit?.map((unit: UnitType, index: number) => {
                            return (
                                <CardPro
                                    key={index}
                                    unit={unit}
                                    idProject={detailProject?.id}
                                    unitStatus={unit?.status}
                                    viewName={viewName}
                                    getData={getData}
                                />
                            )
                        })}
                    </Wrapper>
                }
                {
                    viewName !== "Tower" &&
                    <Pagination
                        isLoading={isLoading}
                        paginator={paginator}
                        setFilters={setFilters}
                        viewName={viewName}
                    />
                }
            </div>

        </main>
    )
}

export default Results